import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent implements OnInit, DoCheck {

  get file(): File {
    return this.control.value;
  }

  @Input() control: FormControl;

  @Input() acceptedFormats: string[] = [];

  @Input() maxFileBytes: number;

  @Input() corrupted = false;

  @Input() isLoading = false;
  @Input() isLoaded = false;
  @Input() edicion = true;
  @Input() mb = 4;

  @Input() public rest: boolean;
  ngDoCheck(): void {
    if (this.rest) {
      this.deleteItem();
      this.rest = false;
    }
  }

  onSelectFile($event: any): void {

    const file = $event.target.files[0] || null;

    if (file) {
      this.control.setValue(file);
      this.control.markAsTouched();
    }
  }

  ngOnInit() {
    this.control.valueChanges.subscribe(() => {
      this.corrupted = false;
    });
  }

  deleteItem(): void {
    this.control.reset();
  }
}
